import React, { useEffect, useReducer, useRef, useState } from 'react'
import Modal from '../../../../../Modal/Modal';
import { useDispatch, useSelector } from 'react-redux';
import styles from "./AiboxForm.module.css"
import Input from '../../../../../CustomDropDown/Input/Input';
import Button1 from '../../../../Button/Button1';
import { addAibox, addCamectAPI, addSigfoxAPI, aiboxLogin, updateCamectAPI } from '../../../../../../Api Methods/Api';
import { checkAuthLoader } from '../../../../../../auth';
import Button2 from '../../../../Button/Button2';
import { Button } from 'primereact/button';

const TextReducer = (state, action) => {

    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: action.val.length > 0 };
    }

    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }

    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: null };
    }

    return { value: '', isValid: false };
}

const AiboxForm = ({ setShowVirtualSource, outputs, fetchVirtualSources }) => {

    const client = useSelector(state => state.auth.client);
    const token = useSelector(state => state.auth.token);
    const DeviceUUID = useSelector(state => state.auth.DeviceUUID);
    const apiData = {
        token,
        client
    }
    const [modalComponent, setModalComponent] = useState(null);
    const [modalPageIndex, setModalPageIndex] = useState(0);
    const [pinSelected, setPinSelected] = useState(null)
    const ModalDialog = useRef();
    const [message, setMessage] = useState("")
    const [invalidIP, setInvalidIP] = useState("")
    const [linkMessage, setLinkMessage] = useState("Attempting to link AIBOX, please wait...")
    const [linkTitle, setLinkTitle] = useState("Logged in successfully!")
    const [loading, setLoading] = useState(false)

    const userID = useSelector(state => state.auth.userID);
    const ipRegex = /^(?:\d{1,3}\.){3}\d{1,3}$/;


    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        HandelResetModal();
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                HandelResetModal();
            }
        };

        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
      
    const [ipAddressState, dispatchIPAddressState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [portState, dispatchPortState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [usernameState, dispatchUsernameState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const [passwordState, dispatchPasswordState] = useReducer(TextReducer, {
        value: '',
        isValid: null
    });

    const ipAddressRef = useRef();
    const portRef = useRef();
    const usernameRef = useRef();
    const passwordRef = useRef();

    function validateIPAddress(value) {
        if (value == ''){
            return null
        }

        if (/^https?:\/\//i.test(value)) {
            return "Do not include http:// or https://";
        }

        if (/:\d+$/.test(value)) {
            return "Do not include port number in this field";
        }

        // if (!ipRegex.test(value)) {
        //     return "Invalid IP address format";
        // }

        return "";
    }

    const ipAddressChangeHandler = (e) => {
        const value = e.target.value;
        const errorMessage = validateIPAddress(value);

        dispatchIPAddressState({ type: "USER_INPUT", val: value });
        setInvalidIP(errorMessage);
    };


    const portChangeHandler = (event) => {
        dispatchPortState({ type: 'USER_INPUT', val: event.target.value });
    }

    const usernameChangeHandler = (event) => {
        dispatchUsernameState({ type: 'USER_INPUT', val: event.target.value });
    }

    const passwordChangeHandler = (event) => {
        dispatchPasswordState({ type: 'USER_INPUT', val: event.target.value });
    }

    const HandelResetModal = () => {
        setModalPageIndex(null);
        setShowVirtualSource(null);
    }

    const dispatch = useDispatch();

    const submitHandler = async (event) => {
        event.preventDefault();
    };

    const HandlePinSelected = (pin) => {
        setPinSelected(pin);
        setModalPageIndex(1);
    }

    const HandleLogin = async () => {
        setMessage("") //reset 
        let loginBody = {
            "protocol": "https",
            "hostName": ipAddressState.value,
            "port": portState.value,
            "username": usernameState.value,
            "password": passwordState.value,
            "userID": userID
        }

        console.log(loginBody)

        const loginResponse = await aiboxLogin(apiData, loginBody, dispatch)
        if (loginResponse.success) {
            const fullIP = `${ipAddressState.value}:${portState.value}`
            let addBody = {
                "siteUUID": DeviceUUID,
                "pinNumber": pinSelected,
                "userID": userID,
                "ipAndPort": fullIP
            }

            //HandleCloseModal();
            setModalPageIndex(2)

            const linkResponse = await addAibox(apiData, addBody, dispatch)
            if (linkResponse.success){
                //HandleCloseModal();
                fetchVirtualSources();
                setLinkTitle("Complete!")
                setLinkMessage("AIBOX linked successfully")
            } else {
                setLinkTitle("Error!")
                setLinkMessage("Failed to link AIBOX, please try again")
            }
        } else {
            console.log("here?")
            setMessage("Failed to login to AIBOX, please check your credentials & try again")
        }
    }

    useEffect(() => {
        switch (modalPageIndex) {
            case 0:
                setModalComponent(
                    <form onSubmit={submitHandler} className={styles["container1"]} method="dialog">
                        <h3 style={{color:"#6e6e6e"}}>Which output would you like to link the AIBOX to?</h3>
                        <br></br>
                        <small style={{color:"#6e6e6e"}}>Please make sure the AIBOX and your selected output are set to the same state.</small>                        
                        <small style={{color:"#6e6e6e"}}>If they are different, the first command will only be used to sync them and</small>
                        <small style={{color:"#6e6e6e"}}>will NOT change the AIBOX.</small>
                        <br></br>
                        <br></br>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: "15px" }}>
                            
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "20px", width: "100%" }}>
                                    <ul style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center", gap: "10px" }}>
                                    {outputs.map((output) => {
                                            return (
                                                <li key={output.Pin}>
                                                    <Button2 style={{minWidth:"350px", minHeight:"50px"}}type={"button"} onClick={() => HandlePinSelected(output.Pin)}>
                                                        {output.pinName}
                                                    </Button2>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </form>
                )
                HandleShowModal();
                break;
            case 1:
                setModalComponent(
                    <div className={`${styles.container}`}>
                        <div className={`${styles.card}`}>
                            {message && <p className={styles.errorMessage}>{message}</p>}
                            <h2 style={{color:"#6e6e6e"}}>Login & Link AIBOX</h2>
                            <p style={{color:"#6e6e6e"}}>Login to your AIBOX account by completing the fields below</p>

                            <br></br>
                            <small style={{color:"#6e6e6e"}}>Please do not include 'https://' or port in the IP Address</small>
                            <br></br>
                            {invalidIP && <small className={styles.errorMessage}>{invalidIP}</small>}

                            <input
                                placeholder={"IP Address"}
                                ref={ipAddressRef}
                                id="ipAddress"
                                value={ipAddressState.value}
                                onChange={ipAddressChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <input
                                placeholder={"Port"}
                                ref={portRef}
                                id="port"
                                value={portState.value}
                                onChange={portChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Username"}
                                ref={usernameRef}
                                id="username"
                                value={usernameState.value}
                                onChange={usernameChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />
                            <input
                                placeholder={"Password"}
                                ref={passwordRef}
                                id="password"
                                value={passwordState.value}
                                onChange={passwordChangeHandler}
                                type="text"
                                className={`${styles.inputField}`}
                                required
                            />

                            <br></br>

                            <Button severity="info" type="submit" disabled={loading} onClick={HandleLogin}>
                                {loading ? "Logging in..." : "Log in & link AIBOX"}
                            </Button>
                        </div>
                    </div>    
                   
                )

                HandleShowModal();
            break;
            case 2: 
                setModalComponent(
                    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <h3 style={{color:"#6e6e6eff"}}>{linkTitle}</h3>
                        <br></br>
                        <p style={{color:"#6e6e6eff"}}>{linkMessage}</p>
                        <br></br>
                        <Button severity="info" type="submit" disabled={loading} onClick={HandleCloseModal}>
                                {"Close"}
                        </Button>
                    </div>
                )

                HandleShowModal();
            break; 
        }
    }, [modalPageIndex, ipAddressState, portState, usernameState, passwordState, linkMessage, linkTitle, message]);

    return (
        <>
            <Modal ref={ModalDialog} title={"Add AIBOX"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
                {modalComponent}
            </Modal>
        </>
    )
}

export default AiboxForm;